import { Link } from "react-router-dom";

import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { PageEnum, useSpaceContext } from "@tudigo-monorepo/tudigo-session";
import { ButtonRebrand } from "@tudigo-monorepo/web-tudigo-components";
import { UI_PROJECTS_COMPARATOR_PROJECT_LINK_CLICKED } from "@tudigo-monorepo/web-tudigo-tracking";

import { useProjectsComparatorCustomerTracking } from "../../../hooks/use-projects-comparator-customer-tracking";

export function ProjectsComparatorProjectLink({
  project,
}: {
  project: Project;
}) {
  const { currentPagePaths } = useSpaceContext();
  const { customerTrackComparator } = useProjectsComparatorCustomerTracking();

  return (
    <ButtonRebrand
      asChild
      className="mt-auto w-full"
      variant="accent-light"
      onClick={() => {
        customerTrackComparator(UI_PROJECTS_COMPARATOR_PROJECT_LINK_CLICKED, {
          project_id: project.id,
          project_name: project.content?.name,
        });
      }}
    >
      <Link
        target="_blank"
        to={currentPagePaths[PageEnum.PROJECT].replace(
          ":projectId",
          project.content?.slug ?? project.id,
        )}
      >
        Voir le projet
      </Link>
    </ButtonRebrand>
  );
}
